<template>
  <span class="ew-status" :class="'ew-status--' + info.tone" :title="status && info.label !== status ? status : null">
    <span class="ew-status-dot"></span>{{ info.label }}
  </span>
</template>

<script>
import { trackingStatus } from '@/utils/format'

// Estatus de rastreo traducido al español y con color según la etapa del envío
export default {
  name: 'TrackingStatus',
  props: {
    status: { type: String, default: '' }
  },
  computed: {
    info() {
      return trackingStatus(this.status)
    }
  }
}
</script>

<style scoped>
.ew-status {
  --c: #4a5064;
  --bg: #f6f7fb;
  --bd: #dfe2ec;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 8px;
  border: 1px solid var(--bd);
  border-radius: 6px;
  background: var(--bg);
  color: var(--c);
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.35;
  white-space: nowrap;
}

.ew-status-dot {
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--c);
}

.ew-status--created { --c: #4a5064; --bg: #f6f7fb; --bd: #dfe2ec; }
.ew-status--transit { --c: #1d4ed8; --bg: #eff4ff; --bd: #c7d7fe; }
.ew-status--delivery { --c: #b45309; --bg: #fff7ed; --bd: #fcd9b0; }
.ew-status--delivered { --c: #15803d; --bg: #effaf3; --bd: #bfe5cc; }
.ew-status--issue { --c: #c2410c; --bg: #fff3ed; --bd: #fdc9b0; }
.ew-status--cancelled { --c: #b91c1c; --bg: #fef2f2; --bd: #f6c6c6; }
.ew-status--none { --c: #9aa0b1; --bg: #ffffff; --bd: #eceef5; }
</style>



// WEBPACK FOOTER //
// src/components/ui/TrackingStatus.vue